export function extractDataFromCourseForMultiCard(data) {

    let returnData = {};

    returnData.featureBackground = data?.course?.blogBanner || data?.course?.coverImage || data?.course?.coverIcon;
    returnData.title = data?.course?.data?.course?.internalTitle || data?.course?.internalTitle;
    returnData.description = data?.course?.shortDesc || data?.course?.longDesc;

    let parts = [];
    data?.course?.sessions?.map((item, index) => {
        parts.push(
            {
                partImage: item?.verticalRectangle || item?.coverImage || item?.coverIcon,
                partTitle: item?.title,
                type: "course",
                identifiers: {
                    sessionId: item?.sessionId,
                    courseId: item?.courseId
                },
                allData: { ...data, sessionIndex: index }
            }
        )
    })

    returnData.parts = parts;

    return returnData;

}